"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v5.27.3
// source: contract.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.OsInformationContext = exports.Mkdir = exports.Approval_Rejected = exports.Approval_Approved = exports.Approval_PolicyRef = exports.Approval = exports.AdditionalContext = exports.RunMCPTool = exports.Icons = exports.McpTool = exports.ToolAnnotations = exports.Icon = exports.FindFiles = exports.Grep = exports.ListDirectory = exports.NewCheckpoint_AgentContextUsageEntry = exports.NewCheckpoint = exports.TokenBreakdown = exports.ListFlowsResponse = exports.ListFlowsRequestFilter = exports.ListFlowsRequest = exports.ListToolsResponse = exports.ListToolsRequest = exports.ListCapabilitiesResponse = exports.ListCapabilitiesRequest = exports.Capability = exports.GenerateTokenResponse = exports.GenerateTokenRequest = exports.RunGitCommand = exports.RunHTTPRequest = exports.EditFile = exports.WriteFile = exports.ReadFiles = exports.ReadFile = exports.RunCommandAction = exports.RunShellCommand = exports.TrackLlmCallForSelfHosted = exports.ScheduleNotification = exports.Action = exports.ScheduleNotificationResponse = exports.HttpResponse_HeadersEntry = exports.HttpResponse = exports.PlainTextResponse = exports.StopWorkflowRequest = exports.HeartbeatRequest = exports.ActionResponse = exports.StartWorkflowRequest = exports.ClientEvent = exports.Approval_ApprovalSource = exports.protobufPackage = void 0;
exports.DuoWorkflowClient = exports.DuoWorkflowService = exports.ValidateFlowConfigResponse = exports.ValidateFlowConfigRequest = exports.TrackSelfHostedAction = exports.TrackSelfHostedClientEvent = exports.ShellInformationContext = void 0;
exports.approval_ApprovalSourceFromJSON = approval_ApprovalSourceFromJSON;
exports.approval_ApprovalSourceToJSON = approval_ApprovalSourceToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const grpc_js_1 = require("@grpc/grpc-js");
const struct_1 = require("./google/protobuf/struct");
exports.protobufPackage = "";
/**
 * ApprovalSource identifies who or what the client reports made the approval decision.
 * Informational only: the value is client-provided and is not verified server-side.
 *
 * Values name the proximate decision MECHANISM, not the policy content or its
 * author: a PreToolUse hook approval is APPROVAL_SOURCE_PRETOOLUSE_HOOK whether the matched
 * policy is GitLab's distributed default policy or a customer-authored local
 * policy. Policy provenance (author/origin/version of the matched policy) is
 * carried separately, never as new enum values. Add values only for genuinely
 * new decision mechanisms, for example a server-side governance preapproval
 * that bypasses client approval entirely.
 */
var Approval_ApprovalSource;
(function (Approval_ApprovalSource) {
    /** APPROVAL_SOURCE_UNSPECIFIED - APPROVAL_SOURCE_UNSPECIFIED is the default value when the source is unknown or not set by the client. */
    Approval_ApprovalSource[Approval_ApprovalSource["APPROVAL_SOURCE_UNSPECIFIED"] = 0] = "APPROVAL_SOURCE_UNSPECIFIED";
    /** APPROVAL_SOURCE_USER_EXPLICIT - APPROVAL_SOURCE_USER_EXPLICIT indicates a human explicitly approved the action (e.g. clicking "approve" in a UI). */
    Approval_ApprovalSource[Approval_ApprovalSource["APPROVAL_SOURCE_USER_EXPLICIT"] = 1] = "APPROVAL_SOURCE_USER_EXPLICIT";
    /** APPROVAL_SOURCE_PRETOOLUSE_HOOK - APPROVAL_SOURCE_PRETOOLUSE_HOOK indicates the approval was granted automatically by a PreToolUse hook. */
    Approval_ApprovalSource[Approval_ApprovalSource["APPROVAL_SOURCE_PRETOOLUSE_HOOK"] = 2] = "APPROVAL_SOURCE_PRETOOLUSE_HOOK";
    /** APPROVAL_SOURCE_AUTO_MODE - APPROVAL_SOURCE_AUTO_MODE indicates the approval was granted automatically by auto-mode. */
    Approval_ApprovalSource[Approval_ApprovalSource["APPROVAL_SOURCE_AUTO_MODE"] = 3] = "APPROVAL_SOURCE_AUTO_MODE";
    /** APPROVAL_SOURCE_PREAPPROVED_CONFIG - APPROVAL_SOURCE_PREAPPROVED_CONFIG indicates the approval was granted via a pre-approved tool/pattern configuration. */
    Approval_ApprovalSource[Approval_ApprovalSource["APPROVAL_SOURCE_PREAPPROVED_CONFIG"] = 4] = "APPROVAL_SOURCE_PREAPPROVED_CONFIG";
    Approval_ApprovalSource[Approval_ApprovalSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Approval_ApprovalSource || (exports.Approval_ApprovalSource = Approval_ApprovalSource = {}));
function approval_ApprovalSourceFromJSON(object) {
    switch (object) {
        case 0:
        case "APPROVAL_SOURCE_UNSPECIFIED":
            return Approval_ApprovalSource.APPROVAL_SOURCE_UNSPECIFIED;
        case 1:
        case "APPROVAL_SOURCE_USER_EXPLICIT":
            return Approval_ApprovalSource.APPROVAL_SOURCE_USER_EXPLICIT;
        case 2:
        case "APPROVAL_SOURCE_PRETOOLUSE_HOOK":
            return Approval_ApprovalSource.APPROVAL_SOURCE_PRETOOLUSE_HOOK;
        case 3:
        case "APPROVAL_SOURCE_AUTO_MODE":
            return Approval_ApprovalSource.APPROVAL_SOURCE_AUTO_MODE;
        case 4:
        case "APPROVAL_SOURCE_PREAPPROVED_CONFIG":
            return Approval_ApprovalSource.APPROVAL_SOURCE_PREAPPROVED_CONFIG;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Approval_ApprovalSource.UNRECOGNIZED;
    }
}
function approval_ApprovalSourceToJSON(object) {
    switch (object) {
        case Approval_ApprovalSource.APPROVAL_SOURCE_UNSPECIFIED:
            return "APPROVAL_SOURCE_UNSPECIFIED";
        case Approval_ApprovalSource.APPROVAL_SOURCE_USER_EXPLICIT:
            return "APPROVAL_SOURCE_USER_EXPLICIT";
        case Approval_ApprovalSource.APPROVAL_SOURCE_PRETOOLUSE_HOOK:
            return "APPROVAL_SOURCE_PRETOOLUSE_HOOK";
        case Approval_ApprovalSource.APPROVAL_SOURCE_AUTO_MODE:
            return "APPROVAL_SOURCE_AUTO_MODE";
        case Approval_ApprovalSource.APPROVAL_SOURCE_PREAPPROVED_CONFIG:
            return "APPROVAL_SOURCE_PREAPPROVED_CONFIG";
        case Approval_ApprovalSource.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseClientEvent() {
    return { startRequest: undefined, actionResponse: undefined, heartbeat: undefined, stopWorkflow: undefined };
}
exports.ClientEvent = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.startRequest !== undefined) {
            exports.StartWorkflowRequest.encode(message.startRequest, writer.uint32(10).fork()).join();
        }
        if (message.actionResponse !== undefined) {
            exports.ActionResponse.encode(message.actionResponse, writer.uint32(18).fork()).join();
        }
        if (message.heartbeat !== undefined) {
            exports.HeartbeatRequest.encode(message.heartbeat, writer.uint32(26).fork()).join();
        }
        if (message.stopWorkflow !== undefined) {
            exports.StopWorkflowRequest.encode(message.stopWorkflow, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseClientEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.startRequest = exports.StartWorkflowRequest.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.actionResponse = exports.ActionResponse.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.heartbeat = exports.HeartbeatRequest.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.stopWorkflow = exports.StopWorkflowRequest.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            startRequest: isSet(object.startRequest) ? exports.StartWorkflowRequest.fromJSON(object.startRequest) : undefined,
            actionResponse: isSet(object.actionResponse) ? exports.ActionResponse.fromJSON(object.actionResponse) : undefined,
            heartbeat: isSet(object.heartbeat) ? exports.HeartbeatRequest.fromJSON(object.heartbeat) : undefined,
            stopWorkflow: isSet(object.stopWorkflow) ? exports.StopWorkflowRequest.fromJSON(object.stopWorkflow) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.startRequest !== undefined) {
            obj.startRequest = exports.StartWorkflowRequest.toJSON(message.startRequest);
        }
        if (message.actionResponse !== undefined) {
            obj.actionResponse = exports.ActionResponse.toJSON(message.actionResponse);
        }
        if (message.heartbeat !== undefined) {
            obj.heartbeat = exports.HeartbeatRequest.toJSON(message.heartbeat);
        }
        if (message.stopWorkflow !== undefined) {
            obj.stopWorkflow = exports.StopWorkflowRequest.toJSON(message.stopWorkflow);
        }
        return obj;
    },
    create(base) {
        return exports.ClientEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseClientEvent();
        message.startRequest = (object.startRequest !== undefined && object.startRequest !== null)
            ? exports.StartWorkflowRequest.fromPartial(object.startRequest)
            : undefined;
        message.actionResponse = (object.actionResponse !== undefined && object.actionResponse !== null)
            ? exports.ActionResponse.fromPartial(object.actionResponse)
            : undefined;
        message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
            ? exports.HeartbeatRequest.fromPartial(object.heartbeat)
            : undefined;
        message.stopWorkflow = (object.stopWorkflow !== undefined && object.stopWorkflow !== null)
            ? exports.StopWorkflowRequest.fromPartial(object.stopWorkflow)
            : undefined;
        return message;
    },
};
function createBaseStartWorkflowRequest() {
    return {
        clientVersion: "",
        workflowID: "",
        workflowDefinition: "",
        goal: "",
        workflowMetadata: "",
        clientCapabilities: [],
        mcpTools: [],
        additional_context: [],
        approval: undefined,
        flowConfig: undefined,
        flowConfigSchemaVersion: undefined,
        preapproved_tools: [],
        flowConfigId: undefined,
        flowVersion: undefined,
        streaming: undefined,
        resume_checkpoint_ts: undefined,
    };
}
exports.StartWorkflowRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.clientVersion !== "") {
            writer.uint32(10).string(message.clientVersion);
        }
        if (message.workflowID !== "") {
            writer.uint32(18).string(message.workflowID);
        }
        if (message.workflowDefinition !== "") {
            writer.uint32(26).string(message.workflowDefinition);
        }
        if (message.goal !== "") {
            writer.uint32(34).string(message.goal);
        }
        if (message.workflowMetadata !== "") {
            writer.uint32(42).string(message.workflowMetadata);
        }
        for (const v of message.clientCapabilities) {
            writer.uint32(50).string(v);
        }
        for (const v of message.mcpTools) {
            exports.McpTool.encode(v, writer.uint32(66).fork()).join();
        }
        for (const v of message.additional_context) {
            exports.AdditionalContext.encode(v, writer.uint32(74).fork()).join();
        }
        if (message.approval !== undefined) {
            exports.Approval.encode(message.approval, writer.uint32(82).fork()).join();
        }
        if (message.flowConfig !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.flowConfig), writer.uint32(90).fork()).join();
        }
        if (message.flowConfigSchemaVersion !== undefined) {
            writer.uint32(98).string(message.flowConfigSchemaVersion);
        }
        for (const v of message.preapproved_tools) {
            writer.uint32(106).string(v);
        }
        if (message.flowConfigId !== undefined) {
            writer.uint32(114).string(message.flowConfigId);
        }
        if (message.flowVersion !== undefined) {
            writer.uint32(122).string(message.flowVersion);
        }
        if (message.streaming !== undefined) {
            writer.uint32(128).bool(message.streaming);
        }
        if (message.resume_checkpoint_ts !== undefined) {
            writer.uint32(138).string(message.resume_checkpoint_ts);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStartWorkflowRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.clientVersion = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.workflowID = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.workflowDefinition = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.goal = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.workflowMetadata = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.clientCapabilities.push(reader.string());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.mcpTools.push(exports.McpTool.decode(reader, reader.uint32()));
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.additional_context.push(exports.AdditionalContext.decode(reader, reader.uint32()));
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.approval = exports.Approval.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.flowConfig = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.flowConfigSchemaVersion = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.preapproved_tools.push(reader.string());
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.flowConfigId = reader.string();
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.flowVersion = reader.string();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.streaming = reader.bool();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.resume_checkpoint_ts = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            clientVersion: isSet(object.clientVersion) ? globalThis.String(object.clientVersion) : "",
            workflowID: isSet(object.workflowID) ? globalThis.String(object.workflowID) : "",
            workflowDefinition: isSet(object.workflowDefinition) ? globalThis.String(object.workflowDefinition) : "",
            goal: isSet(object.goal) ? globalThis.String(object.goal) : "",
            workflowMetadata: isSet(object.workflowMetadata) ? globalThis.String(object.workflowMetadata) : "",
            clientCapabilities: globalThis.Array.isArray(object?.clientCapabilities)
                ? object.clientCapabilities.map((e) => globalThis.String(e))
                : [],
            mcpTools: globalThis.Array.isArray(object?.mcpTools) ? object.mcpTools.map((e) => exports.McpTool.fromJSON(e)) : [],
            additional_context: globalThis.Array.isArray(object?.additional_context)
                ? object.additional_context.map((e) => exports.AdditionalContext.fromJSON(e))
                : [],
            approval: isSet(object.approval) ? exports.Approval.fromJSON(object.approval) : undefined,
            flowConfig: isObject(object.flowConfig) ? object.flowConfig : undefined,
            flowConfigSchemaVersion: isSet(object.flowConfigSchemaVersion)
                ? globalThis.String(object.flowConfigSchemaVersion)
                : undefined,
            preapproved_tools: globalThis.Array.isArray(object?.preapproved_tools)
                ? object.preapproved_tools.map((e) => globalThis.String(e))
                : [],
            flowConfigId: isSet(object.flowConfigId) ? globalThis.String(object.flowConfigId) : undefined,
            flowVersion: isSet(object.flowVersion) ? globalThis.String(object.flowVersion) : undefined,
            streaming: isSet(object.streaming) ? globalThis.Boolean(object.streaming) : undefined,
            resume_checkpoint_ts: isSet(object.resume_checkpoint_ts)
                ? globalThis.String(object.resume_checkpoint_ts)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.clientVersion !== "") {
            obj.clientVersion = message.clientVersion;
        }
        if (message.workflowID !== "") {
            obj.workflowID = message.workflowID;
        }
        if (message.workflowDefinition !== "") {
            obj.workflowDefinition = message.workflowDefinition;
        }
        if (message.goal !== "") {
            obj.goal = message.goal;
        }
        if (message.workflowMetadata !== "") {
            obj.workflowMetadata = message.workflowMetadata;
        }
        if (message.clientCapabilities?.length) {
            obj.clientCapabilities = message.clientCapabilities;
        }
        if (message.mcpTools?.length) {
            obj.mcpTools = message.mcpTools.map((e) => exports.McpTool.toJSON(e));
        }
        if (message.additional_context?.length) {
            obj.additional_context = message.additional_context.map((e) => exports.AdditionalContext.toJSON(e));
        }
        if (message.approval !== undefined) {
            obj.approval = exports.Approval.toJSON(message.approval);
        }
        if (message.flowConfig !== undefined) {
            obj.flowConfig = message.flowConfig;
        }
        if (message.flowConfigSchemaVersion !== undefined) {
            obj.flowConfigSchemaVersion = message.flowConfigSchemaVersion;
        }
        if (message.preapproved_tools?.length) {
            obj.preapproved_tools = message.preapproved_tools;
        }
        if (message.flowConfigId !== undefined) {
            obj.flowConfigId = message.flowConfigId;
        }
        if (message.flowVersion !== undefined) {
            obj.flowVersion = message.flowVersion;
        }
        if (message.streaming !== undefined) {
            obj.streaming = message.streaming;
        }
        if (message.resume_checkpoint_ts !== undefined) {
            obj.resume_checkpoint_ts = message.resume_checkpoint_ts;
        }
        return obj;
    },
    create(base) {
        return exports.StartWorkflowRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartWorkflowRequest();
        message.clientVersion = object.clientVersion ?? "";
        message.workflowID = object.workflowID ?? "";
        message.workflowDefinition = object.workflowDefinition ?? "";
        message.goal = object.goal ?? "";
        message.workflowMetadata = object.workflowMetadata ?? "";
        message.clientCapabilities = object.clientCapabilities?.map((e) => e) || [];
        message.mcpTools = object.mcpTools?.map((e) => exports.McpTool.fromPartial(e)) || [];
        message.additional_context = object.additional_context?.map((e) => exports.AdditionalContext.fromPartial(e)) || [];
        message.approval = (object.approval !== undefined && object.approval !== null)
            ? exports.Approval.fromPartial(object.approval)
            : undefined;
        message.flowConfig = object.flowConfig ?? undefined;
        message.flowConfigSchemaVersion = object.flowConfigSchemaVersion ?? undefined;
        message.preapproved_tools = object.preapproved_tools?.map((e) => e) || [];
        message.flowConfigId = object.flowConfigId ?? undefined;
        message.flowVersion = object.flowVersion ?? undefined;
        message.streaming = object.streaming ?? undefined;
        message.resume_checkpoint_ts = object.resume_checkpoint_ts ?? undefined;
        return message;
    },
};
function createBaseActionResponse() {
    return {
        requestID: "",
        plainTextResponse: undefined,
        httpResponse: undefined,
        scheduleNotificationResponse: undefined,
    };
}
exports.ActionResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestID !== "") {
            writer.uint32(10).string(message.requestID);
        }
        if (message.plainTextResponse !== undefined) {
            exports.PlainTextResponse.encode(message.plainTextResponse, writer.uint32(26).fork()).join();
        }
        if (message.httpResponse !== undefined) {
            exports.HttpResponse.encode(message.httpResponse, writer.uint32(34).fork()).join();
        }
        if (message.scheduleNotificationResponse !== undefined) {
            exports.ScheduleNotificationResponse.encode(message.scheduleNotificationResponse, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseActionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestID = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.plainTextResponse = exports.PlainTextResponse.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.httpResponse = exports.HttpResponse.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.scheduleNotificationResponse = exports.ScheduleNotificationResponse.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestID: isSet(object.requestID) ? globalThis.String(object.requestID) : "",
            plainTextResponse: isSet(object.plainTextResponse)
                ? exports.PlainTextResponse.fromJSON(object.plainTextResponse)
                : undefined,
            httpResponse: isSet(object.httpResponse) ? exports.HttpResponse.fromJSON(object.httpResponse) : undefined,
            scheduleNotificationResponse: isSet(object.scheduleNotificationResponse)
                ? exports.ScheduleNotificationResponse.fromJSON(object.scheduleNotificationResponse)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestID !== "") {
            obj.requestID = message.requestID;
        }
        if (message.plainTextResponse !== undefined) {
            obj.plainTextResponse = exports.PlainTextResponse.toJSON(message.plainTextResponse);
        }
        if (message.httpResponse !== undefined) {
            obj.httpResponse = exports.HttpResponse.toJSON(message.httpResponse);
        }
        if (message.scheduleNotificationResponse !== undefined) {
            obj.scheduleNotificationResponse = exports.ScheduleNotificationResponse.toJSON(message.scheduleNotificationResponse);
        }
        return obj;
    },
    create(base) {
        return exports.ActionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActionResponse();
        message.requestID = object.requestID ?? "";
        message.plainTextResponse = (object.plainTextResponse !== undefined && object.plainTextResponse !== null)
            ? exports.PlainTextResponse.fromPartial(object.plainTextResponse)
            : undefined;
        message.httpResponse = (object.httpResponse !== undefined && object.httpResponse !== null)
            ? exports.HttpResponse.fromPartial(object.httpResponse)
            : undefined;
        message.scheduleNotificationResponse =
            (object.scheduleNotificationResponse !== undefined && object.scheduleNotificationResponse !== null)
                ? exports.ScheduleNotificationResponse.fromPartial(object.scheduleNotificationResponse)
                : undefined;
        return message;
    },
};
function createBaseHeartbeatRequest() {
    return { timestamp: 0 };
}
exports.HeartbeatRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timestamp !== 0) {
            writer.uint32(8).int64(message.timestamp);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeartbeatRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.timestamp = longToNumber(reader.int64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.timestamp !== 0) {
            obj.timestamp = Math.round(message.timestamp);
        }
        return obj;
    },
    create(base) {
        return exports.HeartbeatRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeartbeatRequest();
        message.timestamp = object.timestamp ?? 0;
        return message;
    },
};
function createBaseStopWorkflowRequest() {
    return { reason: "" };
}
exports.StopWorkflowRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.reason !== "") {
            writer.uint32(10).string(message.reason);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStopWorkflowRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { reason: isSet(object.reason) ? globalThis.String(object.reason) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        return obj;
    },
    create(base) {
        return exports.StopWorkflowRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStopWorkflowRequest();
        message.reason = object.reason ?? "";
        return message;
    },
};
function createBasePlainTextResponse() {
    return { response: "", error: "" };
}
exports.PlainTextResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.response !== "") {
            writer.uint32(10).string(message.response);
        }
        if (message.error !== "") {
            writer.uint32(18).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlainTextResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.response = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            response: isSet(object.response) ? globalThis.String(object.response) : "",
            error: isSet(object.error) ? globalThis.String(object.error) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.response !== "") {
            obj.response = message.response;
        }
        if (message.error !== "") {
            obj.error = message.error;
        }
        return obj;
    },
    create(base) {
        return exports.PlainTextResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlainTextResponse();
        message.response = object.response ?? "";
        message.error = object.error ?? "";
        return message;
    },
};
function createBaseHttpResponse() {
    return { headers: {}, statusCode: 0, body: "", error: "" };
}
exports.HttpResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        Object.entries(message.headers).forEach(([key, value]) => {
            exports.HttpResponse_HeadersEntry.encode({ key: key, value }, writer.uint32(10).fork()).join();
        });
        if (message.statusCode !== 0) {
            writer.uint32(16).int32(message.statusCode);
        }
        if (message.body !== "") {
            writer.uint32(26).string(message.body);
        }
        if (message.error !== "") {
            writer.uint32(34).string(message.error);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHttpResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.HttpResponse_HeadersEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.headers[entry1.key] = entry1.value;
                    }
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusCode = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.body = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.error = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            headers: isObject(object.headers)
                ? Object.entries(object.headers).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            statusCode: isSet(object.statusCode) ? globalThis.Number(object.statusCode) : 0,
            body: isSet(object.body) ? globalThis.String(object.body) : "",
            error: isSet(object.error) ? globalThis.String(object.error) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.headers) {
            const entries = Object.entries(message.headers);
            if (entries.length > 0) {
                obj.headers = {};
                entries.forEach(([k, v]) => {
                    obj.headers[k] = v;
                });
            }
        }
        if (message.statusCode !== 0) {
            obj.statusCode = Math.round(message.statusCode);
        }
        if (message.body !== "") {
            obj.body = message.body;
        }
        if (message.error !== "") {
            obj.error = message.error;
        }
        return obj;
    },
    create(base) {
        return exports.HttpResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHttpResponse();
        message.headers = Object.entries(object.headers ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.statusCode = object.statusCode ?? 0;
        message.body = object.body ?? "";
        message.error = object.error ?? "";
        return message;
    },
};
function createBaseHttpResponse_HeadersEntry() {
    return { key: "", value: "" };
}
exports.HttpResponse_HeadersEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHttpResponse_HeadersEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.HttpResponse_HeadersEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHttpResponse_HeadersEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseScheduleNotificationResponse() {
    return { accepted: false, reason: "", fires_at: "" };
}
exports.ScheduleNotificationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.accepted !== false) {
            writer.uint32(8).bool(message.accepted);
        }
        if (message.reason !== "") {
            writer.uint32(18).string(message.reason);
        }
        if (message.fires_at !== "") {
            writer.uint32(26).string(message.fires_at);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScheduleNotificationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.accepted = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.fires_at = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            accepted: isSet(object.accepted) ? globalThis.Boolean(object.accepted) : false,
            reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
            fires_at: isSet(object.fires_at) ? globalThis.String(object.fires_at) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.accepted !== false) {
            obj.accepted = message.accepted;
        }
        if (message.reason !== "") {
            obj.reason = message.reason;
        }
        if (message.fires_at !== "") {
            obj.fires_at = message.fires_at;
        }
        return obj;
    },
    create(base) {
        return exports.ScheduleNotificationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScheduleNotificationResponse();
        message.accepted = object.accepted ?? false;
        message.reason = object.reason ?? "";
        message.fires_at = object.fires_at ?? "";
        return message;
    },
};
function createBaseAction() {
    return {
        requestID: "",
        runCommand: undefined,
        runHTTPRequest: undefined,
        runReadFile: undefined,
        runWriteFile: undefined,
        runGitCommand: undefined,
        runEditFile: undefined,
        newCheckpoint: undefined,
        listDirectory: undefined,
        grep: undefined,
        findFiles: undefined,
        runMCPTool: undefined,
        mkdir: undefined,
        runReadFiles: undefined,
        runShellCommand: undefined,
        trackLlmCallForSelfHosted: undefined,
        scheduleNotification: undefined,
    };
}
exports.Action = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestID !== "") {
            writer.uint32(10).string(message.requestID);
        }
        if (message.runCommand !== undefined) {
            exports.RunCommandAction.encode(message.runCommand, writer.uint32(18).fork()).join();
        }
        if (message.runHTTPRequest !== undefined) {
            exports.RunHTTPRequest.encode(message.runHTTPRequest, writer.uint32(26).fork()).join();
        }
        if (message.runReadFile !== undefined) {
            exports.ReadFile.encode(message.runReadFile, writer.uint32(34).fork()).join();
        }
        if (message.runWriteFile !== undefined) {
            exports.WriteFile.encode(message.runWriteFile, writer.uint32(42).fork()).join();
        }
        if (message.runGitCommand !== undefined) {
            exports.RunGitCommand.encode(message.runGitCommand, writer.uint32(50).fork()).join();
        }
        if (message.runEditFile !== undefined) {
            exports.EditFile.encode(message.runEditFile, writer.uint32(58).fork()).join();
        }
        if (message.newCheckpoint !== undefined) {
            exports.NewCheckpoint.encode(message.newCheckpoint, writer.uint32(66).fork()).join();
        }
        if (message.listDirectory !== undefined) {
            exports.ListDirectory.encode(message.listDirectory, writer.uint32(74).fork()).join();
        }
        if (message.grep !== undefined) {
            exports.Grep.encode(message.grep, writer.uint32(82).fork()).join();
        }
        if (message.findFiles !== undefined) {
            exports.FindFiles.encode(message.findFiles, writer.uint32(90).fork()).join();
        }
        if (message.runMCPTool !== undefined) {
            exports.RunMCPTool.encode(message.runMCPTool, writer.uint32(98).fork()).join();
        }
        if (message.mkdir !== undefined) {
            exports.Mkdir.encode(message.mkdir, writer.uint32(106).fork()).join();
        }
        if (message.runReadFiles !== undefined) {
            exports.ReadFiles.encode(message.runReadFiles, writer.uint32(114).fork()).join();
        }
        if (message.runShellCommand !== undefined) {
            exports.RunShellCommand.encode(message.runShellCommand, writer.uint32(122).fork()).join();
        }
        if (message.trackLlmCallForSelfHosted !== undefined) {
            exports.TrackLlmCallForSelfHosted.encode(message.trackLlmCallForSelfHosted, writer.uint32(130).fork()).join();
        }
        if (message.scheduleNotification !== undefined) {
            exports.ScheduleNotification.encode(message.scheduleNotification, writer.uint32(138).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestID = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.runCommand = exports.RunCommandAction.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.runHTTPRequest = exports.RunHTTPRequest.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.runReadFile = exports.ReadFile.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.runWriteFile = exports.WriteFile.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.runGitCommand = exports.RunGitCommand.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.runEditFile = exports.EditFile.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.newCheckpoint = exports.NewCheckpoint.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.listDirectory = exports.ListDirectory.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.grep = exports.Grep.decode(reader, reader.uint32());
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.findFiles = exports.FindFiles.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.runMCPTool = exports.RunMCPTool.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.mkdir = exports.Mkdir.decode(reader, reader.uint32());
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.runReadFiles = exports.ReadFiles.decode(reader, reader.uint32());
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.runShellCommand = exports.RunShellCommand.decode(reader, reader.uint32());
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.trackLlmCallForSelfHosted = exports.TrackLlmCallForSelfHosted.decode(reader, reader.uint32());
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.scheduleNotification = exports.ScheduleNotification.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestID: isSet(object.requestID) ? globalThis.String(object.requestID) : "",
            runCommand: isSet(object.runCommand) ? exports.RunCommandAction.fromJSON(object.runCommand) : undefined,
            runHTTPRequest: isSet(object.runHTTPRequest) ? exports.RunHTTPRequest.fromJSON(object.runHTTPRequest) : undefined,
            runReadFile: isSet(object.runReadFile) ? exports.ReadFile.fromJSON(object.runReadFile) : undefined,
            runWriteFile: isSet(object.runWriteFile) ? exports.WriteFile.fromJSON(object.runWriteFile) : undefined,
            runGitCommand: isSet(object.runGitCommand) ? exports.RunGitCommand.fromJSON(object.runGitCommand) : undefined,
            runEditFile: isSet(object.runEditFile) ? exports.EditFile.fromJSON(object.runEditFile) : undefined,
            newCheckpoint: isSet(object.newCheckpoint) ? exports.NewCheckpoint.fromJSON(object.newCheckpoint) : undefined,
            listDirectory: isSet(object.listDirectory) ? exports.ListDirectory.fromJSON(object.listDirectory) : undefined,
            grep: isSet(object.grep) ? exports.Grep.fromJSON(object.grep) : undefined,
            findFiles: isSet(object.findFiles) ? exports.FindFiles.fromJSON(object.findFiles) : undefined,
            runMCPTool: isSet(object.runMCPTool) ? exports.RunMCPTool.fromJSON(object.runMCPTool) : undefined,
            mkdir: isSet(object.mkdir) ? exports.Mkdir.fromJSON(object.mkdir) : undefined,
            runReadFiles: isSet(object.runReadFiles) ? exports.ReadFiles.fromJSON(object.runReadFiles) : undefined,
            runShellCommand: isSet(object.runShellCommand) ? exports.RunShellCommand.fromJSON(object.runShellCommand) : undefined,
            trackLlmCallForSelfHosted: isSet(object.trackLlmCallForSelfHosted)
                ? exports.TrackLlmCallForSelfHosted.fromJSON(object.trackLlmCallForSelfHosted)
                : undefined,
            scheduleNotification: isSet(object.scheduleNotification)
                ? exports.ScheduleNotification.fromJSON(object.scheduleNotification)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestID !== "") {
            obj.requestID = message.requestID;
        }
        if (message.runCommand !== undefined) {
            obj.runCommand = exports.RunCommandAction.toJSON(message.runCommand);
        }
        if (message.runHTTPRequest !== undefined) {
            obj.runHTTPRequest = exports.RunHTTPRequest.toJSON(message.runHTTPRequest);
        }
        if (message.runReadFile !== undefined) {
            obj.runReadFile = exports.ReadFile.toJSON(message.runReadFile);
        }
        if (message.runWriteFile !== undefined) {
            obj.runWriteFile = exports.WriteFile.toJSON(message.runWriteFile);
        }
        if (message.runGitCommand !== undefined) {
            obj.runGitCommand = exports.RunGitCommand.toJSON(message.runGitCommand);
        }
        if (message.runEditFile !== undefined) {
            obj.runEditFile = exports.EditFile.toJSON(message.runEditFile);
        }
        if (message.newCheckpoint !== undefined) {
            obj.newCheckpoint = exports.NewCheckpoint.toJSON(message.newCheckpoint);
        }
        if (message.listDirectory !== undefined) {
            obj.listDirectory = exports.ListDirectory.toJSON(message.listDirectory);
        }
        if (message.grep !== undefined) {
            obj.grep = exports.Grep.toJSON(message.grep);
        }
        if (message.findFiles !== undefined) {
            obj.findFiles = exports.FindFiles.toJSON(message.findFiles);
        }
        if (message.runMCPTool !== undefined) {
            obj.runMCPTool = exports.RunMCPTool.toJSON(message.runMCPTool);
        }
        if (message.mkdir !== undefined) {
            obj.mkdir = exports.Mkdir.toJSON(message.mkdir);
        }
        if (message.runReadFiles !== undefined) {
            obj.runReadFiles = exports.ReadFiles.toJSON(message.runReadFiles);
        }
        if (message.runShellCommand !== undefined) {
            obj.runShellCommand = exports.RunShellCommand.toJSON(message.runShellCommand);
        }
        if (message.trackLlmCallForSelfHosted !== undefined) {
            obj.trackLlmCallForSelfHosted = exports.TrackLlmCallForSelfHosted.toJSON(message.trackLlmCallForSelfHosted);
        }
        if (message.scheduleNotification !== undefined) {
            obj.scheduleNotification = exports.ScheduleNotification.toJSON(message.scheduleNotification);
        }
        return obj;
    },
    create(base) {
        return exports.Action.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAction();
        message.requestID = object.requestID ?? "";
        message.runCommand = (object.runCommand !== undefined && object.runCommand !== null)
            ? exports.RunCommandAction.fromPartial(object.runCommand)
            : undefined;
        message.runHTTPRequest = (object.runHTTPRequest !== undefined && object.runHTTPRequest !== null)
            ? exports.RunHTTPRequest.fromPartial(object.runHTTPRequest)
            : undefined;
        message.runReadFile = (object.runReadFile !== undefined && object.runReadFile !== null)
            ? exports.ReadFile.fromPartial(object.runReadFile)
            : undefined;
        message.runWriteFile = (object.runWriteFile !== undefined && object.runWriteFile !== null)
            ? exports.WriteFile.fromPartial(object.runWriteFile)
            : undefined;
        message.runGitCommand = (object.runGitCommand !== undefined && object.runGitCommand !== null)
            ? exports.RunGitCommand.fromPartial(object.runGitCommand)
            : undefined;
        message.runEditFile = (object.runEditFile !== undefined && object.runEditFile !== null)
            ? exports.EditFile.fromPartial(object.runEditFile)
            : undefined;
        message.newCheckpoint = (object.newCheckpoint !== undefined && object.newCheckpoint !== null)
            ? exports.NewCheckpoint.fromPartial(object.newCheckpoint)
            : undefined;
        message.listDirectory = (object.listDirectory !== undefined && object.listDirectory !== null)
            ? exports.ListDirectory.fromPartial(object.listDirectory)
            : undefined;
        message.grep = (object.grep !== undefined && object.grep !== null) ? exports.Grep.fromPartial(object.grep) : undefined;
        message.findFiles = (object.findFiles !== undefined && object.findFiles !== null)
            ? exports.FindFiles.fromPartial(object.findFiles)
            : undefined;
        message.runMCPTool = (object.runMCPTool !== undefined && object.runMCPTool !== null)
            ? exports.RunMCPTool.fromPartial(object.runMCPTool)
            : undefined;
        message.mkdir = (object.mkdir !== undefined && object.mkdir !== null) ? exports.Mkdir.fromPartial(object.mkdir) : undefined;
        message.runReadFiles = (object.runReadFiles !== undefined && object.runReadFiles !== null)
            ? exports.ReadFiles.fromPartial(object.runReadFiles)
            : undefined;
        message.runShellCommand = (object.runShellCommand !== undefined && object.runShellCommand !== null)
            ? exports.RunShellCommand.fromPartial(object.runShellCommand)
            : undefined;
        message.trackLlmCallForSelfHosted =
            (object.trackLlmCallForSelfHosted !== undefined && object.trackLlmCallForSelfHosted !== null)
                ? exports.TrackLlmCallForSelfHosted.fromPartial(object.trackLlmCallForSelfHosted)
                : undefined;
        message.scheduleNotification = (object.scheduleNotification !== undefined && object.scheduleNotification !== null)
            ? exports.ScheduleNotification.fromPartial(object.scheduleNotification)
            : undefined;
        return message;
    },
};
function createBaseScheduleNotification() {
    return { task_id: "", condition: "", message: "" };
}
exports.ScheduleNotification = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.task_id !== "") {
            writer.uint32(10).string(message.task_id);
        }
        if (message.condition !== "") {
            writer.uint32(18).string(message.condition);
        }
        if (message.message !== "") {
            writer.uint32(26).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseScheduleNotification();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.task_id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.condition = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            task_id: isSet(object.task_id) ? globalThis.String(object.task_id) : "",
            condition: isSet(object.condition) ? globalThis.String(object.condition) : "",
            message: isSet(object.message) ? globalThis.String(object.message) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.task_id !== "") {
            obj.task_id = message.task_id;
        }
        if (message.condition !== "") {
            obj.condition = message.condition;
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.ScheduleNotification.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScheduleNotification();
        message.task_id = object.task_id ?? "";
        message.condition = object.condition ?? "";
        message.message = object.message ?? "";
        return message;
    },
};
function createBaseTrackLlmCallForSelfHosted() {
    return { workflowID: "", featureQualifiedName: "", featureAiCatalogItem: false };
}
exports.TrackLlmCallForSelfHosted = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.workflowID !== "") {
            writer.uint32(10).string(message.workflowID);
        }
        if (message.featureQualifiedName !== "") {
            writer.uint32(18).string(message.featureQualifiedName);
        }
        if (message.featureAiCatalogItem !== false) {
            writer.uint32(24).bool(message.featureAiCatalogItem);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTrackLlmCallForSelfHosted();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.workflowID = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.featureQualifiedName = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.featureAiCatalogItem = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            workflowID: isSet(object.workflowID) ? globalThis.String(object.workflowID) : "",
            featureQualifiedName: isSet(object.featureQualifiedName) ? globalThis.String(object.featureQualifiedName) : "",
            featureAiCatalogItem: isSet(object.featureAiCatalogItem)
                ? globalThis.Boolean(object.featureAiCatalogItem)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.workflowID !== "") {
            obj.workflowID = message.workflowID;
        }
        if (message.featureQualifiedName !== "") {
            obj.featureQualifiedName = message.featureQualifiedName;
        }
        if (message.featureAiCatalogItem !== false) {
            obj.featureAiCatalogItem = message.featureAiCatalogItem;
        }
        return obj;
    },
    create(base) {
        return exports.TrackLlmCallForSelfHosted.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTrackLlmCallForSelfHosted();
        message.workflowID = object.workflowID ?? "";
        message.featureQualifiedName = object.featureQualifiedName ?? "";
        message.featureAiCatalogItem = object.featureAiCatalogItem ?? false;
        return message;
    },
};
function createBaseRunShellCommand() {
    return { command: "", timeout: undefined };
}
exports.RunShellCommand = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        if (message.timeout !== undefined) {
            writer.uint32(16).int64(message.timeout);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRunShellCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.timeout = longToNumber(reader.int64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            command: isSet(object.command) ? globalThis.String(object.command) : "",
            timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.command !== "") {
            obj.command = message.command;
        }
        if (message.timeout !== undefined) {
            obj.timeout = Math.round(message.timeout);
        }
        return obj;
    },
    create(base) {
        return exports.RunShellCommand.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRunShellCommand();
        message.command = object.command ?? "";
        message.timeout = object.timeout ?? undefined;
        return message;
    },
};
function createBaseRunCommandAction() {
    return { program: "", arguments: [], flags: [], timeout: undefined };
}
exports.RunCommandAction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.program !== "") {
            writer.uint32(26).string(message.program);
        }
        for (const v of message.arguments) {
            writer.uint32(34).string(v);
        }
        for (const v of message.flags) {
            writer.uint32(42).string(v);
        }
        if (message.timeout !== undefined) {
            writer.uint32(48).int64(message.timeout);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRunCommandAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.program = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.arguments.push(reader.string());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.flags.push(reader.string());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.timeout = longToNumber(reader.int64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            program: isSet(object.program) ? globalThis.String(object.program) : "",
            arguments: globalThis.Array.isArray(object?.arguments)
                ? object.arguments.map((e) => globalThis.String(e))
                : [],
            flags: globalThis.Array.isArray(object?.flags) ? object.flags.map((e) => globalThis.String(e)) : [],
            timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.program !== "") {
            obj.program = message.program;
        }
        if (message.arguments?.length) {
            obj.arguments = message.arguments;
        }
        if (message.flags?.length) {
            obj.flags = message.flags;
        }
        if (message.timeout !== undefined) {
            obj.timeout = Math.round(message.timeout);
        }
        return obj;
    },
    create(base) {
        return exports.RunCommandAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRunCommandAction();
        message.program = object.program ?? "";
        message.arguments = object.arguments?.map((e) => e) || [];
        message.flags = object.flags?.map((e) => e) || [];
        message.timeout = object.timeout ?? undefined;
        return message;
    },
};
function createBaseReadFile() {
    return { filepath: "", limit: undefined, offset: undefined };
}
exports.ReadFile = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filepath !== "") {
            writer.uint32(10).string(message.filepath);
        }
        if (message.limit !== undefined) {
            writer.uint32(16).int64(message.limit);
        }
        if (message.offset !== undefined) {
            writer.uint32(24).int64(message.offset);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReadFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filepath = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.limit = longToNumber(reader.int64());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.offset = longToNumber(reader.int64());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filepath: isSet(object.filepath) ? globalThis.String(object.filepath) : "",
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
            offset: isSet(object.offset) ? globalThis.Number(object.offset) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filepath !== "") {
            obj.filepath = message.filepath;
        }
        if (message.limit !== undefined) {
            obj.limit = Math.round(message.limit);
        }
        if (message.offset !== undefined) {
            obj.offset = Math.round(message.offset);
        }
        return obj;
    },
    create(base) {
        return exports.ReadFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReadFile();
        message.filepath = object.filepath ?? "";
        message.limit = object.limit ?? undefined;
        message.offset = object.offset ?? undefined;
        return message;
    },
};
function createBaseReadFiles() {
    return { filepaths: [] };
}
exports.ReadFiles = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.filepaths) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseReadFiles();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filepaths.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filepaths: globalThis.Array.isArray(object?.filepaths)
                ? object.filepaths.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filepaths?.length) {
            obj.filepaths = message.filepaths;
        }
        return obj;
    },
    create(base) {
        return exports.ReadFiles.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReadFiles();
        message.filepaths = object.filepaths?.map((e) => e) || [];
        return message;
    },
};
function createBaseWriteFile() {
    return { filepath: "", contents: "" };
}
exports.WriteFile = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filepath !== "") {
            writer.uint32(10).string(message.filepath);
        }
        if (message.contents !== "") {
            writer.uint32(18).string(message.contents);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseWriteFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filepath = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.contents = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filepath: isSet(object.filepath) ? globalThis.String(object.filepath) : "",
            contents: isSet(object.contents) ? globalThis.String(object.contents) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filepath !== "") {
            obj.filepath = message.filepath;
        }
        if (message.contents !== "") {
            obj.contents = message.contents;
        }
        return obj;
    },
    create(base) {
        return exports.WriteFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseWriteFile();
        message.filepath = object.filepath ?? "";
        message.contents = object.contents ?? "";
        return message;
    },
};
function createBaseEditFile() {
    return { filepath: "", oldString: "", newString: "" };
}
exports.EditFile = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filepath !== "") {
            writer.uint32(10).string(message.filepath);
        }
        if (message.oldString !== "") {
            writer.uint32(18).string(message.oldString);
        }
        if (message.newString !== "") {
            writer.uint32(26).string(message.newString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEditFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filepath = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.oldString = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.newString = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            filepath: isSet(object.filepath) ? globalThis.String(object.filepath) : "",
            oldString: isSet(object.oldString) ? globalThis.String(object.oldString) : "",
            newString: isSet(object.newString) ? globalThis.String(object.newString) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.filepath !== "") {
            obj.filepath = message.filepath;
        }
        if (message.oldString !== "") {
            obj.oldString = message.oldString;
        }
        if (message.newString !== "") {
            obj.newString = message.newString;
        }
        return obj;
    },
    create(base) {
        return exports.EditFile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEditFile();
        message.filepath = object.filepath ?? "";
        message.oldString = object.oldString ?? "";
        message.newString = object.newString ?? "";
        return message;
    },
};
function createBaseRunHTTPRequest() {
    return { method: "", path: "", body: undefined };
}
exports.RunHTTPRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.method !== "") {
            writer.uint32(10).string(message.method);
        }
        if (message.path !== "") {
            writer.uint32(18).string(message.path);
        }
        if (message.body !== undefined) {
            writer.uint32(26).string(message.body);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRunHTTPRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.method = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.path = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.body = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            method: isSet(object.method) ? globalThis.String(object.method) : "",
            path: isSet(object.path) ? globalThis.String(object.path) : "",
            body: isSet(object.body) ? globalThis.String(object.body) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.method !== "") {
            obj.method = message.method;
        }
        if (message.path !== "") {
            obj.path = message.path;
        }
        if (message.body !== undefined) {
            obj.body = message.body;
        }
        return obj;
    },
    create(base) {
        return exports.RunHTTPRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRunHTTPRequest();
        message.method = object.method ?? "";
        message.path = object.path ?? "";
        message.body = object.body ?? undefined;
        return message;
    },
};
function createBaseRunGitCommand() {
    return { command: "", arguments: undefined, repository_url: "" };
}
exports.RunGitCommand = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.command !== "") {
            writer.uint32(10).string(message.command);
        }
        if (message.arguments !== undefined) {
            writer.uint32(18).string(message.arguments);
        }
        if (message.repository_url !== "") {
            writer.uint32(26).string(message.repository_url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRunGitCommand();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.command = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.arguments = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.repository_url = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            command: isSet(object.command) ? globalThis.String(object.command) : "",
            arguments: isSet(object.arguments) ? globalThis.String(object.arguments) : undefined,
            repository_url: isSet(object.repository_url) ? globalThis.String(object.repository_url) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.command !== "") {
            obj.command = message.command;
        }
        if (message.arguments !== undefined) {
            obj.arguments = message.arguments;
        }
        if (message.repository_url !== "") {
            obj.repository_url = message.repository_url;
        }
        return obj;
    },
    create(base) {
        return exports.RunGitCommand.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRunGitCommand();
        message.command = object.command ?? "";
        message.arguments = object.arguments ?? undefined;
        message.repository_url = object.repository_url ?? "";
        return message;
    },
};
function createBaseGenerateTokenRequest() {
    return { workflowDefinition: undefined };
}
exports.GenerateTokenRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.workflowDefinition !== undefined) {
            writer.uint32(10).string(message.workflowDefinition);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerateTokenRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.workflowDefinition = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            workflowDefinition: isSet(object.workflowDefinition) ? globalThis.String(object.workflowDefinition) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.workflowDefinition !== undefined) {
            obj.workflowDefinition = message.workflowDefinition;
        }
        return obj;
    },
    create(base) {
        return exports.GenerateTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenerateTokenRequest();
        message.workflowDefinition = object.workflowDefinition ?? undefined;
        return message;
    },
};
function createBaseGenerateTokenResponse() {
    return { token: "", expiresAt: 0, server_capabilities: [] };
}
exports.GenerateTokenResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.expiresAt !== 0) {
            writer.uint32(16).int64(message.expiresAt);
        }
        for (const v of message.server_capabilities) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerateTokenResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.expiresAt = longToNumber(reader.int64());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.server_capabilities.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            token: isSet(object.token) ? globalThis.String(object.token) : "",
            expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : 0,
            server_capabilities: globalThis.Array.isArray(object?.server_capabilities)
                ? object.server_capabilities.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== "") {
            obj.token = message.token;
        }
        if (message.expiresAt !== 0) {
            obj.expiresAt = Math.round(message.expiresAt);
        }
        if (message.server_capabilities?.length) {
            obj.server_capabilities = message.server_capabilities;
        }
        return obj;
    },
    create(base) {
        return exports.GenerateTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenerateTokenResponse();
        message.token = object.token ?? "";
        message.expiresAt = object.expiresAt ?? 0;
        message.server_capabilities = object.server_capabilities?.map((e) => e) || [];
        return message;
    },
};
function createBaseCapability() {
    return { name: "", metadata: "" };
}
exports.Capability = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.metadata !== "") {
            writer.uint32(18).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCapability();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.metadata = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.metadata !== "") {
            obj.metadata = message.metadata;
        }
        return obj;
    },
    create(base) {
        return exports.Capability.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCapability();
        message.name = object.name ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    },
};
function createBaseListCapabilitiesRequest() {
    return {};
}
exports.ListCapabilitiesRequest = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListCapabilitiesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ListCapabilitiesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseListCapabilitiesRequest();
        return message;
    },
};
function createBaseListCapabilitiesResponse() {
    return { capabilities: [] };
}
exports.ListCapabilitiesResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.capabilities) {
            exports.Capability.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListCapabilitiesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.capabilities.push(exports.Capability.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            capabilities: globalThis.Array.isArray(object?.capabilities)
                ? object.capabilities.map((e) => exports.Capability.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.capabilities?.length) {
            obj.capabilities = message.capabilities.map((e) => exports.Capability.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListCapabilitiesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListCapabilitiesResponse();
        message.capabilities = object.capabilities?.map((e) => exports.Capability.fromPartial(e)) || [];
        return message;
    },
};
function createBaseListToolsRequest() {
    return {};
}
exports.ListToolsRequest = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListToolsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ListToolsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseListToolsRequest();
        return message;
    },
};
function createBaseListToolsResponse() {
    return { tools: [], eval_dataset: [] };
}
exports.ListToolsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.tools) {
            struct_1.Struct.encode(struct_1.Struct.wrap(v), writer.uint32(10).fork()).join();
        }
        for (const v of message.eval_dataset) {
            struct_1.Struct.encode(struct_1.Struct.wrap(v), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListToolsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.tools.push(struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32())));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.eval_dataset.push(struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32())));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tools: globalThis.Array.isArray(object?.tools) ? [...object.tools] : [],
            eval_dataset: globalThis.Array.isArray(object?.eval_dataset) ? [...object.eval_dataset] : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tools?.length) {
            obj.tools = message.tools;
        }
        if (message.eval_dataset?.length) {
            obj.eval_dataset = message.eval_dataset;
        }
        return obj;
    },
    create(base) {
        return exports.ListToolsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListToolsResponse();
        message.tools = object.tools?.map((e) => e) || [];
        message.eval_dataset = object.eval_dataset?.map((e) => e) || [];
        return message;
    },
};
function createBaseListFlowsRequest() {
    return { filters: undefined };
}
exports.ListFlowsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.filters !== undefined) {
            exports.ListFlowsRequestFilter.encode(message.filters, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFlowsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.filters = exports.ListFlowsRequestFilter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { filters: isSet(object.filters) ? exports.ListFlowsRequestFilter.fromJSON(object.filters) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.filters !== undefined) {
            obj.filters = exports.ListFlowsRequestFilter.toJSON(message.filters);
        }
        return obj;
    },
    create(base) {
        return exports.ListFlowsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFlowsRequest();
        message.filters = (object.filters !== undefined && object.filters !== null)
            ? exports.ListFlowsRequestFilter.fromPartial(object.filters)
            : undefined;
        return message;
    },
};
function createBaseListFlowsRequestFilter() {
    return { flow_identifier: [], environment: [], version: [] };
}
exports.ListFlowsRequestFilter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.flow_identifier) {
            writer.uint32(34).string(v);
        }
        for (const v of message.environment) {
            writer.uint32(18).string(v);
        }
        for (const v of message.version) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFlowsRequestFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.flow_identifier.push(reader.string());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.environment.push(reader.string());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.version.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            flow_identifier: globalThis.Array.isArray(object?.flow_identifier)
                ? object.flow_identifier.map((e) => globalThis.String(e))
                : [],
            environment: globalThis.Array.isArray(object?.environment)
                ? object.environment.map((e) => globalThis.String(e))
                : [],
            version: globalThis.Array.isArray(object?.version) ? object.version.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.flow_identifier?.length) {
            obj.flow_identifier = message.flow_identifier;
        }
        if (message.environment?.length) {
            obj.environment = message.environment;
        }
        if (message.version?.length) {
            obj.version = message.version;
        }
        return obj;
    },
    create(base) {
        return exports.ListFlowsRequestFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFlowsRequestFilter();
        message.flow_identifier = object.flow_identifier?.map((e) => e) || [];
        message.environment = object.environment?.map((e) => e) || [];
        message.version = object.version?.map((e) => e) || [];
        return message;
    },
};
function createBaseListFlowsResponse() {
    return { configs: [] };
}
exports.ListFlowsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.configs) {
            struct_1.Struct.encode(struct_1.Struct.wrap(v), writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListFlowsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.configs.push(struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32())));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { configs: globalThis.Array.isArray(object?.configs) ? [...object.configs] : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.configs?.length) {
            obj.configs = message.configs;
        }
        return obj;
    },
    create(base) {
        return exports.ListFlowsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListFlowsResponse();
        message.configs = object.configs?.map((e) => e) || [];
        return message;
    },
};
function createBaseTokenBreakdown() {
    return { total_tokens: 0, max_tokens: 0 };
}
exports.TokenBreakdown = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.total_tokens !== 0) {
            writer.uint32(8).int32(message.total_tokens);
        }
        if (message.max_tokens !== 0) {
            writer.uint32(16).int32(message.max_tokens);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTokenBreakdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.total_tokens = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.max_tokens = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            total_tokens: isSet(object.total_tokens) ? globalThis.Number(object.total_tokens) : 0,
            max_tokens: isSet(object.max_tokens) ? globalThis.Number(object.max_tokens) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.total_tokens !== 0) {
            obj.total_tokens = Math.round(message.total_tokens);
        }
        if (message.max_tokens !== 0) {
            obj.max_tokens = Math.round(message.max_tokens);
        }
        return obj;
    },
    create(base) {
        return exports.TokenBreakdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTokenBreakdown();
        message.total_tokens = object.total_tokens ?? 0;
        message.max_tokens = object.max_tokens ?? 0;
        return message;
    },
};
function createBaseNewCheckpoint() {
    return { status: "", checkpoint: "", goal: "", errors: [], agent_context_usage: {} };
}
exports.NewCheckpoint = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.status !== "") {
            writer.uint32(10).string(message.status);
        }
        if (message.checkpoint !== "") {
            writer.uint32(18).string(message.checkpoint);
        }
        if (message.goal !== "") {
            writer.uint32(26).string(message.goal);
        }
        for (const v of message.errors) {
            writer.uint32(34).string(v);
        }
        Object.entries(message.agent_context_usage).forEach(([key, value]) => {
            exports.NewCheckpoint_AgentContextUsageEntry.encode({ key: key, value }, writer.uint32(42).fork()).join();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNewCheckpoint();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.status = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.checkpoint = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.goal = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.errors.push(reader.string());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    const entry5 = exports.NewCheckpoint_AgentContextUsageEntry.decode(reader, reader.uint32());
                    if (entry5.value !== undefined) {
                        message.agent_context_usage[entry5.key] = entry5.value;
                    }
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            status: isSet(object.status) ? globalThis.String(object.status) : "",
            checkpoint: isSet(object.checkpoint) ? globalThis.String(object.checkpoint) : "",
            goal: isSet(object.goal) ? globalThis.String(object.goal) : "",
            errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e) => globalThis.String(e)) : [],
            agent_context_usage: isObject(object.agent_context_usage)
                ? Object.entries(object.agent_context_usage).reduce((acc, [key, value]) => {
                    acc[key] = exports.TokenBreakdown.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.status !== "") {
            obj.status = message.status;
        }
        if (message.checkpoint !== "") {
            obj.checkpoint = message.checkpoint;
        }
        if (message.goal !== "") {
            obj.goal = message.goal;
        }
        if (message.errors?.length) {
            obj.errors = message.errors;
        }
        if (message.agent_context_usage) {
            const entries = Object.entries(message.agent_context_usage);
            if (entries.length > 0) {
                obj.agent_context_usage = {};
                entries.forEach(([k, v]) => {
                    obj.agent_context_usage[k] = exports.TokenBreakdown.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.NewCheckpoint.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNewCheckpoint();
        message.status = object.status ?? "";
        message.checkpoint = object.checkpoint ?? "";
        message.goal = object.goal ?? "";
        message.errors = object.errors?.map((e) => e) || [];
        message.agent_context_usage = Object.entries(object.agent_context_usage ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.TokenBreakdown.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseNewCheckpoint_AgentContextUsageEntry() {
    return { key: "", value: undefined };
}
exports.NewCheckpoint_AgentContextUsageEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.TokenBreakdown.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseNewCheckpoint_AgentContextUsageEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.TokenBreakdown.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? exports.TokenBreakdown.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.TokenBreakdown.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.NewCheckpoint_AgentContextUsageEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNewCheckpoint_AgentContextUsageEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.TokenBreakdown.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseListDirectory() {
    return { directory: "" };
}
exports.ListDirectory = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.directory !== "") {
            writer.uint32(10).string(message.directory);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListDirectory();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.directory = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { directory: isSet(object.directory) ? globalThis.String(object.directory) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.directory !== "") {
            obj.directory = message.directory;
        }
        return obj;
    },
    create(base) {
        return exports.ListDirectory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseListDirectory();
        message.directory = object.directory ?? "";
        return message;
    },
};
function createBaseGrep() {
    return { search_directory: "", pattern: "", case_insensitive: false };
}
exports.Grep = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.search_directory !== "") {
            writer.uint32(10).string(message.search_directory);
        }
        if (message.pattern !== "") {
            writer.uint32(18).string(message.pattern);
        }
        if (message.case_insensitive !== false) {
            writer.uint32(24).bool(message.case_insensitive);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGrep();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.search_directory = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.pattern = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.case_insensitive = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            search_directory: isSet(object.search_directory) ? globalThis.String(object.search_directory) : "",
            pattern: isSet(object.pattern) ? globalThis.String(object.pattern) : "",
            case_insensitive: isSet(object.case_insensitive) ? globalThis.Boolean(object.case_insensitive) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.search_directory !== "") {
            obj.search_directory = message.search_directory;
        }
        if (message.pattern !== "") {
            obj.pattern = message.pattern;
        }
        if (message.case_insensitive !== false) {
            obj.case_insensitive = message.case_insensitive;
        }
        return obj;
    },
    create(base) {
        return exports.Grep.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGrep();
        message.search_directory = object.search_directory ?? "";
        message.pattern = object.pattern ?? "";
        message.case_insensitive = object.case_insensitive ?? false;
        return message;
    },
};
function createBaseFindFiles() {
    return { name_pattern: "" };
}
exports.FindFiles = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name_pattern !== "") {
            writer.uint32(10).string(message.name_pattern);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFindFiles();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name_pattern = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { name_pattern: isSet(object.name_pattern) ? globalThis.String(object.name_pattern) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.name_pattern !== "") {
            obj.name_pattern = message.name_pattern;
        }
        return obj;
    },
    create(base) {
        return exports.FindFiles.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFindFiles();
        message.name_pattern = object.name_pattern ?? "";
        return message;
    },
};
function createBaseIcon() {
    return { url: "", mime_type: undefined, sizes: [], theme: undefined };
}
exports.Icon = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.url !== "") {
            writer.uint32(10).string(message.url);
        }
        if (message.mime_type !== undefined) {
            writer.uint32(18).string(message.mime_type);
        }
        for (const v of message.sizes) {
            writer.uint32(26).string(v);
        }
        if (message.theme !== undefined) {
            writer.uint32(34).string(message.theme);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIcon();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mime_type = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.sizes.push(reader.string());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.theme = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            mime_type: isSet(object.mime_type) ? globalThis.String(object.mime_type) : undefined,
            sizes: globalThis.Array.isArray(object?.sizes) ? object.sizes.map((e) => globalThis.String(e)) : [],
            theme: isSet(object.theme) ? globalThis.String(object.theme) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.mime_type !== undefined) {
            obj.mime_type = message.mime_type;
        }
        if (message.sizes?.length) {
            obj.sizes = message.sizes;
        }
        if (message.theme !== undefined) {
            obj.theme = message.theme;
        }
        return obj;
    },
    create(base) {
        return exports.Icon.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIcon();
        message.url = object.url ?? "";
        message.mime_type = object.mime_type ?? undefined;
        message.sizes = object.sizes?.map((e) => e) || [];
        message.theme = object.theme ?? undefined;
        return message;
    },
};
function createBaseToolAnnotations() {
    return {
        title: undefined,
        read_only_hint: undefined,
        destructive_hint: undefined,
        idempotent_hint: undefined,
        open_world_hint: undefined,
    };
}
exports.ToolAnnotations = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.title !== undefined) {
            writer.uint32(10).string(message.title);
        }
        if (message.read_only_hint !== undefined) {
            writer.uint32(16).bool(message.read_only_hint);
        }
        if (message.destructive_hint !== undefined) {
            writer.uint32(24).bool(message.destructive_hint);
        }
        if (message.idempotent_hint !== undefined) {
            writer.uint32(32).bool(message.idempotent_hint);
        }
        if (message.open_world_hint !== undefined) {
            writer.uint32(40).bool(message.open_world_hint);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseToolAnnotations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.read_only_hint = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.destructive_hint = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.idempotent_hint = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.open_world_hint = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            title: isSet(object.title) ? globalThis.String(object.title) : undefined,
            read_only_hint: isSet(object.read_only_hint) ? globalThis.Boolean(object.read_only_hint) : undefined,
            destructive_hint: isSet(object.destructive_hint) ? globalThis.Boolean(object.destructive_hint) : undefined,
            idempotent_hint: isSet(object.idempotent_hint) ? globalThis.Boolean(object.idempotent_hint) : undefined,
            open_world_hint: isSet(object.open_world_hint) ? globalThis.Boolean(object.open_world_hint) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.read_only_hint !== undefined) {
            obj.read_only_hint = message.read_only_hint;
        }
        if (message.destructive_hint !== undefined) {
            obj.destructive_hint = message.destructive_hint;
        }
        if (message.idempotent_hint !== undefined) {
            obj.idempotent_hint = message.idempotent_hint;
        }
        if (message.open_world_hint !== undefined) {
            obj.open_world_hint = message.open_world_hint;
        }
        return obj;
    },
    create(base) {
        return exports.ToolAnnotations.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseToolAnnotations();
        message.title = object.title ?? undefined;
        message.read_only_hint = object.read_only_hint ?? undefined;
        message.destructive_hint = object.destructive_hint ?? undefined;
        message.idempotent_hint = object.idempotent_hint ?? undefined;
        message.open_world_hint = object.open_world_hint ?? undefined;
        return message;
    },
};
function createBaseMcpTool() {
    return { name: "", description: "", inputSchema: "", icons: undefined, annotations: undefined, trusted: undefined };
}
exports.McpTool = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        if (message.inputSchema !== "") {
            writer.uint32(26).string(message.inputSchema);
        }
        if (message.icons !== undefined) {
            exports.Icons.encode(message.icons, writer.uint32(34).fork()).join();
        }
        if (message.annotations !== undefined) {
            exports.ToolAnnotations.encode(message.annotations, writer.uint32(42).fork()).join();
        }
        if (message.trusted !== undefined) {
            writer.uint32(48).bool(message.trusted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMcpTool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.inputSchema = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.icons = exports.Icons.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.annotations = exports.ToolAnnotations.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.trusted = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            inputSchema: isSet(object.inputSchema) ? globalThis.String(object.inputSchema) : "",
            icons: isSet(object.icons) ? exports.Icons.fromJSON(object.icons) : undefined,
            annotations: isSet(object.annotations) ? exports.ToolAnnotations.fromJSON(object.annotations) : undefined,
            trusted: isSet(object.trusted) ? globalThis.Boolean(object.trusted) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.inputSchema !== "") {
            obj.inputSchema = message.inputSchema;
        }
        if (message.icons !== undefined) {
            obj.icons = exports.Icons.toJSON(message.icons);
        }
        if (message.annotations !== undefined) {
            obj.annotations = exports.ToolAnnotations.toJSON(message.annotations);
        }
        if (message.trusted !== undefined) {
            obj.trusted = message.trusted;
        }
        return obj;
    },
    create(base) {
        return exports.McpTool.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMcpTool();
        message.name = object.name ?? "";
        message.description = object.description ?? "";
        message.inputSchema = object.inputSchema ?? "";
        message.icons = (object.icons !== undefined && object.icons !== null) ? exports.Icons.fromPartial(object.icons) : undefined;
        message.annotations = (object.annotations !== undefined && object.annotations !== null)
            ? exports.ToolAnnotations.fromPartial(object.annotations)
            : undefined;
        message.trusted = object.trusted ?? undefined;
        return message;
    },
};
function createBaseIcons() {
    return { items: [] };
}
exports.Icons = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.items) {
            exports.Icon.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIcons();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(exports.Icon.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { items: globalThis.Array.isArray(object?.items) ? object.items.map((e) => exports.Icon.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.items?.length) {
            obj.items = message.items.map((e) => exports.Icon.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Icons.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIcons();
        message.items = object.items?.map((e) => exports.Icon.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRunMCPTool() {
    return { name: "", args: "" };
}
exports.RunMCPTool = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.args !== "") {
            writer.uint32(18).string(message.args);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRunMCPTool();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.args = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            args: isSet(object.args) ? globalThis.String(object.args) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.args !== "") {
            obj.args = message.args;
        }
        return obj;
    },
    create(base) {
        return exports.RunMCPTool.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRunMCPTool();
        message.name = object.name ?? "";
        message.args = object.args ?? "";
        return message;
    },
};
function createBaseAdditionalContext() {
    return { category: "", id: undefined, content: undefined, metadata: undefined };
}
exports.AdditionalContext = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.category !== "") {
            writer.uint32(10).string(message.category);
        }
        if (message.id !== undefined) {
            writer.uint32(18).string(message.id);
        }
        if (message.content !== undefined) {
            writer.uint32(26).string(message.content);
        }
        if (message.metadata !== undefined) {
            writer.uint32(34).string(message.metadata);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdditionalContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.category = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.content = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.metadata = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            category: isSet(object.category) ? globalThis.String(object.category) : "",
            id: isSet(object.id) ? globalThis.String(object.id) : undefined,
            content: isSet(object.content) ? globalThis.String(object.content) : undefined,
            metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.category !== "") {
            obj.category = message.category;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        if (message.content !== undefined) {
            obj.content = message.content;
        }
        if (message.metadata !== undefined) {
            obj.metadata = message.metadata;
        }
        return obj;
    },
    create(base) {
        return exports.AdditionalContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAdditionalContext();
        message.category = object.category ?? "";
        message.id = object.id ?? undefined;
        message.content = object.content ?? undefined;
        message.metadata = object.metadata ?? undefined;
        return message;
    },
};
function createBaseApproval() {
    return { approval: undefined, rejection: undefined };
}
exports.Approval = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.approval !== undefined) {
            exports.Approval_Approved.encode(message.approval, writer.uint32(10).fork()).join();
        }
        if (message.rejection !== undefined) {
            exports.Approval_Rejected.encode(message.rejection, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApproval();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.approval = exports.Approval_Approved.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.rejection = exports.Approval_Rejected.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            approval: isSet(object.approval) ? exports.Approval_Approved.fromJSON(object.approval) : undefined,
            rejection: isSet(object.rejection) ? exports.Approval_Rejected.fromJSON(object.rejection) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.approval !== undefined) {
            obj.approval = exports.Approval_Approved.toJSON(message.approval);
        }
        if (message.rejection !== undefined) {
            obj.rejection = exports.Approval_Rejected.toJSON(message.rejection);
        }
        return obj;
    },
    create(base) {
        return exports.Approval.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApproval();
        message.approval = (object.approval !== undefined && object.approval !== null)
            ? exports.Approval_Approved.fromPartial(object.approval)
            : undefined;
        message.rejection = (object.rejection !== undefined && object.rejection !== null)
            ? exports.Approval_Rejected.fromPartial(object.rejection)
            : undefined;
        return message;
    },
};
function createBaseApproval_PolicyRef() {
    return { origin: undefined, file: undefined, hash: undefined, version: undefined };
}
exports.Approval_PolicyRef = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.origin !== undefined) {
            writer.uint32(10).string(message.origin);
        }
        if (message.file !== undefined) {
            writer.uint32(18).string(message.file);
        }
        if (message.hash !== undefined) {
            writer.uint32(26).string(message.hash);
        }
        if (message.version !== undefined) {
            writer.uint32(34).string(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApproval_PolicyRef();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.origin = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.file = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.hash = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.version = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            origin: isSet(object.origin) ? globalThis.String(object.origin) : undefined,
            file: isSet(object.file) ? globalThis.String(object.file) : undefined,
            hash: isSet(object.hash) ? globalThis.String(object.hash) : undefined,
            version: isSet(object.version) ? globalThis.String(object.version) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.origin !== undefined) {
            obj.origin = message.origin;
        }
        if (message.file !== undefined) {
            obj.file = message.file;
        }
        if (message.hash !== undefined) {
            obj.hash = message.hash;
        }
        if (message.version !== undefined) {
            obj.version = message.version;
        }
        return obj;
    },
    create(base) {
        return exports.Approval_PolicyRef.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApproval_PolicyRef();
        message.origin = object.origin ?? undefined;
        message.file = object.file ?? undefined;
        message.hash = object.hash ?? undefined;
        message.version = object.version ?? undefined;
        return message;
    },
};
function createBaseApproval_Approved() {
    return {
        remember_approval: undefined,
        tool_name: undefined,
        tool_args_json: undefined,
        approval_source: undefined,
        policy_ref: undefined,
    };
}
exports.Approval_Approved = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.remember_approval !== undefined) {
            writer.uint32(8).bool(message.remember_approval);
        }
        if (message.tool_name !== undefined) {
            writer.uint32(18).string(message.tool_name);
        }
        if (message.tool_args_json !== undefined) {
            writer.uint32(26).string(message.tool_args_json);
        }
        if (message.approval_source !== undefined) {
            writer.uint32(32).int32(message.approval_source);
        }
        if (message.policy_ref !== undefined) {
            exports.Approval_PolicyRef.encode(message.policy_ref, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApproval_Approved();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.remember_approval = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.tool_name = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.tool_args_json = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.approval_source = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.policy_ref = exports.Approval_PolicyRef.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            remember_approval: isSet(object.remember_approval) ? globalThis.Boolean(object.remember_approval) : undefined,
            tool_name: isSet(object.tool_name) ? globalThis.String(object.tool_name) : undefined,
            tool_args_json: isSet(object.tool_args_json) ? globalThis.String(object.tool_args_json) : undefined,
            approval_source: isSet(object.approval_source)
                ? approval_ApprovalSourceFromJSON(object.approval_source)
                : undefined,
            policy_ref: isSet(object.policy_ref) ? exports.Approval_PolicyRef.fromJSON(object.policy_ref) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.remember_approval !== undefined) {
            obj.remember_approval = message.remember_approval;
        }
        if (message.tool_name !== undefined) {
            obj.tool_name = message.tool_name;
        }
        if (message.tool_args_json !== undefined) {
            obj.tool_args_json = message.tool_args_json;
        }
        if (message.approval_source !== undefined) {
            obj.approval_source = approval_ApprovalSourceToJSON(message.approval_source);
        }
        if (message.policy_ref !== undefined) {
            obj.policy_ref = exports.Approval_PolicyRef.toJSON(message.policy_ref);
        }
        return obj;
    },
    create(base) {
        return exports.Approval_Approved.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApproval_Approved();
        message.remember_approval = object.remember_approval ?? undefined;
        message.tool_name = object.tool_name ?? undefined;
        message.tool_args_json = object.tool_args_json ?? undefined;
        message.approval_source = object.approval_source ?? undefined;
        message.policy_ref = (object.policy_ref !== undefined && object.policy_ref !== null)
            ? exports.Approval_PolicyRef.fromPartial(object.policy_ref)
            : undefined;
        return message;
    },
};
function createBaseApproval_Rejected() {
    return { message: undefined };
}
exports.Approval_Rejected = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.message !== undefined) {
            writer.uint32(10).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApproval_Rejected();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { message: isSet(object.message) ? globalThis.String(object.message) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = message.message;
        }
        return obj;
    },
    create(base) {
        return exports.Approval_Rejected.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseApproval_Rejected();
        message.message = object.message ?? undefined;
        return message;
    },
};
function createBaseMkdir() {
    return { directory_path: "" };
}
exports.Mkdir = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.directory_path !== "") {
            writer.uint32(10).string(message.directory_path);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMkdir();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.directory_path = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { directory_path: isSet(object.directory_path) ? globalThis.String(object.directory_path) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.directory_path !== "") {
            obj.directory_path = message.directory_path;
        }
        return obj;
    },
    create(base) {
        return exports.Mkdir.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMkdir();
        message.directory_path = object.directory_path ?? "";
        return message;
    },
};
function createBaseOsInformationContext() {
    return { platform: "", architecture: "" };
}
exports.OsInformationContext = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.platform !== "") {
            writer.uint32(10).string(message.platform);
        }
        if (message.architecture !== "") {
            writer.uint32(18).string(message.architecture);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOsInformationContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.platform = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.architecture = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            platform: isSet(object.platform) ? globalThis.String(object.platform) : "",
            architecture: isSet(object.architecture) ? globalThis.String(object.architecture) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.platform !== "") {
            obj.platform = message.platform;
        }
        if (message.architecture !== "") {
            obj.architecture = message.architecture;
        }
        return obj;
    },
    create(base) {
        return exports.OsInformationContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOsInformationContext();
        message.platform = object.platform ?? "";
        message.architecture = object.architecture ?? "";
        return message;
    },
};
function createBaseShellInformationContext() {
    return {
        shell_name: "",
        shell_type: "",
        shell_variant: undefined,
        shell_environment: undefined,
        ssh_session: undefined,
        cwd: undefined,
    };
}
exports.ShellInformationContext = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.shell_name !== "") {
            writer.uint32(10).string(message.shell_name);
        }
        if (message.shell_type !== "") {
            writer.uint32(18).string(message.shell_type);
        }
        if (message.shell_variant !== undefined) {
            writer.uint32(26).string(message.shell_variant);
        }
        if (message.shell_environment !== undefined) {
            writer.uint32(34).string(message.shell_environment);
        }
        if (message.ssh_session !== undefined) {
            writer.uint32(40).bool(message.ssh_session);
        }
        if (message.cwd !== undefined) {
            writer.uint32(50).string(message.cwd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShellInformationContext();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.shell_name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.shell_type = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.shell_variant = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.shell_environment = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.ssh_session = reader.bool();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.cwd = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            shell_name: isSet(object.shell_name) ? globalThis.String(object.shell_name) : "",
            shell_type: isSet(object.shell_type) ? globalThis.String(object.shell_type) : "",
            shell_variant: isSet(object.shell_variant) ? globalThis.String(object.shell_variant) : undefined,
            shell_environment: isSet(object.shell_environment) ? globalThis.String(object.shell_environment) : undefined,
            ssh_session: isSet(object.ssh_session) ? globalThis.Boolean(object.ssh_session) : undefined,
            cwd: isSet(object.cwd) ? globalThis.String(object.cwd) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.shell_name !== "") {
            obj.shell_name = message.shell_name;
        }
        if (message.shell_type !== "") {
            obj.shell_type = message.shell_type;
        }
        if (message.shell_variant !== undefined) {
            obj.shell_variant = message.shell_variant;
        }
        if (message.shell_environment !== undefined) {
            obj.shell_environment = message.shell_environment;
        }
        if (message.ssh_session !== undefined) {
            obj.ssh_session = message.ssh_session;
        }
        if (message.cwd !== undefined) {
            obj.cwd = message.cwd;
        }
        return obj;
    },
    create(base) {
        return exports.ShellInformationContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseShellInformationContext();
        message.shell_name = object.shell_name ?? "";
        message.shell_type = object.shell_type ?? "";
        message.shell_variant = object.shell_variant ?? undefined;
        message.shell_environment = object.shell_environment ?? undefined;
        message.ssh_session = object.ssh_session ?? undefined;
        message.cwd = object.cwd ?? undefined;
        return message;
    },
};
function createBaseTrackSelfHostedClientEvent() {
    return { requestID: "", workflowID: "", featureQualifiedName: "", featureAiCatalogItem: false };
}
exports.TrackSelfHostedClientEvent = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestID !== "") {
            writer.uint32(10).string(message.requestID);
        }
        if (message.workflowID !== "") {
            writer.uint32(18).string(message.workflowID);
        }
        if (message.featureQualifiedName !== "") {
            writer.uint32(26).string(message.featureQualifiedName);
        }
        if (message.featureAiCatalogItem !== false) {
            writer.uint32(32).bool(message.featureAiCatalogItem);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTrackSelfHostedClientEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestID = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.workflowID = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.featureQualifiedName = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.featureAiCatalogItem = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            requestID: isSet(object.requestID) ? globalThis.String(object.requestID) : "",
            workflowID: isSet(object.workflowID) ? globalThis.String(object.workflowID) : "",
            featureQualifiedName: isSet(object.featureQualifiedName) ? globalThis.String(object.featureQualifiedName) : "",
            featureAiCatalogItem: isSet(object.featureAiCatalogItem)
                ? globalThis.Boolean(object.featureAiCatalogItem)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestID !== "") {
            obj.requestID = message.requestID;
        }
        if (message.workflowID !== "") {
            obj.workflowID = message.workflowID;
        }
        if (message.featureQualifiedName !== "") {
            obj.featureQualifiedName = message.featureQualifiedName;
        }
        if (message.featureAiCatalogItem !== false) {
            obj.featureAiCatalogItem = message.featureAiCatalogItem;
        }
        return obj;
    },
    create(base) {
        return exports.TrackSelfHostedClientEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTrackSelfHostedClientEvent();
        message.requestID = object.requestID ?? "";
        message.workflowID = object.workflowID ?? "";
        message.featureQualifiedName = object.featureQualifiedName ?? "";
        message.featureAiCatalogItem = object.featureAiCatalogItem ?? false;
        return message;
    },
};
function createBaseTrackSelfHostedAction() {
    return { requestID: "" };
}
exports.TrackSelfHostedAction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.requestID !== "") {
            writer.uint32(10).string(message.requestID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTrackSelfHostedAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.requestID = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { requestID: isSet(object.requestID) ? globalThis.String(object.requestID) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.requestID !== "") {
            obj.requestID = message.requestID;
        }
        return obj;
    },
    create(base) {
        return exports.TrackSelfHostedAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTrackSelfHostedAction();
        message.requestID = object.requestID ?? "";
        return message;
    },
};
function createBaseValidateFlowConfigRequest() {
    return { flow_config: undefined };
}
exports.ValidateFlowConfigRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.flow_config !== undefined) {
            struct_1.Struct.encode(struct_1.Struct.wrap(message.flow_config), writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidateFlowConfigRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.flow_config = struct_1.Struct.unwrap(struct_1.Struct.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { flow_config: isObject(object.flow_config) ? object.flow_config : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.flow_config !== undefined) {
            obj.flow_config = message.flow_config;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateFlowConfigRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateFlowConfigRequest();
        message.flow_config = object.flow_config ?? undefined;
        return message;
    },
};
function createBaseValidateFlowConfigResponse() {
    return { valid: false, errors: [] };
}
exports.ValidateFlowConfigResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.valid !== false) {
            writer.uint32(8).bool(message.valid);
        }
        for (const v of message.errors) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidateFlowConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.valid = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.errors.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            valid: isSet(object.valid) ? globalThis.Boolean(object.valid) : false,
            errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.valid !== false) {
            obj.valid = message.valid;
        }
        if (message.errors?.length) {
            obj.errors = message.errors;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateFlowConfigResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateFlowConfigResponse();
        message.valid = object.valid ?? false;
        message.errors = object.errors?.map((e) => e) || [];
        return message;
    },
};
exports.DuoWorkflowService = {
    /** ExecuteWorkflow starts a bidirectional streaming session for running a Duo Workflow. */
    executeWorkflow: {
        path: "/DuoWorkflow/ExecuteWorkflow",
        requestStream: true,
        responseStream: true,
        requestSerialize: (value) => Buffer.from(exports.ClientEvent.encode(value).finish()),
        requestDeserialize: (value) => exports.ClientEvent.decode(value),
        responseSerialize: (value) => Buffer.from(exports.Action.encode(value).finish()),
        responseDeserialize: (value) => exports.Action.decode(value),
    },
    /** GenerateToken issues a short-lived authentication token for a workflow session. */
    generateToken: {
        path: "/DuoWorkflow/GenerateToken",
        requestStream: false,
        responseStream: false,
        requestSerialize: (value) => Buffer.from(exports.GenerateTokenRequest.encode(value).finish()),
        requestDeserialize: (value) => exports.GenerateTokenRequest.decode(value),
        responseSerialize: (value) => Buffer.from(exports.GenerateTokenResponse.encode(value).finish()),
        responseDeserialize: (value) => exports.GenerateTokenResponse.decode(value),
    },
    /** ListCapabilities returns the capabilities advertised by the server for capability negotiation. */
    listCapabilities: {
        path: "/DuoWorkflow/ListCapabilities",
        requestStream: false,
        responseStream: false,
        requestSerialize: (value) => Buffer.from(exports.ListCapabilitiesRequest.encode(value).finish()),
        requestDeserialize: (value) => exports.ListCapabilitiesRequest.decode(value),
        responseSerialize: (value) => Buffer.from(exports.ListCapabilitiesResponse.encode(value).finish()),
        responseDeserialize: (value) => exports.ListCapabilitiesResponse.decode(value),
    },
    /** ListTools returns the set of tools available to the workflow executor. */
    listTools: {
        path: "/DuoWorkflow/ListTools",
        requestStream: false,
        responseStream: false,
        requestSerialize: (value) => Buffer.from(exports.ListToolsRequest.encode(value).finish()),
        requestDeserialize: (value) => exports.ListToolsRequest.decode(value),
        responseSerialize: (value) => Buffer.from(exports.ListToolsResponse.encode(value).finish()),
        responseDeserialize: (value) => exports.ListToolsResponse.decode(value),
    },
    /** ListFlows returns the set of flow configurations available for execution. */
    listFlows: {
        path: "/DuoWorkflow/ListFlows",
        requestStream: false,
        responseStream: false,
        requestSerialize: (value) => Buffer.from(exports.ListFlowsRequest.encode(value).finish()),
        requestDeserialize: (value) => exports.ListFlowsRequest.decode(value),
        responseSerialize: (value) => Buffer.from(exports.ListFlowsResponse.encode(value).finish()),
        responseDeserialize: (value) => exports.ListFlowsResponse.decode(value),
    },
    /**
     * TrackSelfHostedExecuteWorkflow is the billing bridge for self-hosted Duo deployments using
     * cloud (online) licensing. Workhorse opens this bidirectional stream to Cloud DWS for the
     * lifetime of a workflow. Cloud DWS performs an upfront quota check on stream open. For each
     * LLM call, the self-hosted DWS sends a TrackSelfHostedClientEvent; Cloud DWS responds with a
     * TrackSelfHostedAction to allow or deny the call. LLM traffic never leaves customer infrastructure.
     */
    trackSelfHostedExecuteWorkflow: {
        path: "/DuoWorkflow/TrackSelfHostedExecuteWorkflow",
        requestStream: true,
        responseStream: true,
        requestSerialize: (value) => Buffer.from(exports.TrackSelfHostedClientEvent.encode(value).finish()),
        requestDeserialize: (value) => exports.TrackSelfHostedClientEvent.decode(value),
        responseSerialize: (value) => Buffer.from(exports.TrackSelfHostedAction.encode(value).finish()),
        responseDeserialize: (value) => exports.TrackSelfHostedAction.decode(value),
    },
    /** ValidateFlowConfig validates a provided flow configuration against the registered schema. */
    validateFlowConfig: {
        path: "/DuoWorkflow/ValidateFlowConfig",
        requestStream: false,
        responseStream: false,
        requestSerialize: (value) => Buffer.from(exports.ValidateFlowConfigRequest.encode(value).finish()),
        requestDeserialize: (value) => exports.ValidateFlowConfigRequest.decode(value),
        responseSerialize: (value) => Buffer.from(exports.ValidateFlowConfigResponse.encode(value).finish()),
        responseDeserialize: (value) => exports.ValidateFlowConfigResponse.decode(value),
    },
};
exports.DuoWorkflowClient = (0, grpc_js_1.makeGenericClientConstructor)(exports.DuoWorkflowService, "DuoWorkflow");
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=contract.js.map